import React, { useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "./Styles/contact.css"; // Custom styles for contact page
import { motion } from "framer-motion";
import LayOut from "../components/LayOut.js";
import ProfilePhoto from "../../assets/profile photo.jpg"; // Replace with your profile photo path
import {
  FaLinkedinIn,
  FaGithubAlt,
  FaDiscord,
  FaWhatsapp,
} from "react-icons/fa";
import toast from "react-hot-toast";

const ContactPage = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  });
  const [status, setStatus] = useState("");

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus("Sending...");
    try {
      const response = await fetch(
        "https://portfoliomern-mxue.onrender.com/api/v1/contact/create-contact",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(formData),
        }
      );

      if (response.ok) {
        setStatus("Message sent successfully!");
        setFormData({ name: "", email: "", message: "" });
        toast.success("Message sent successfully!");
      } else {
        setStatus("Failed to send message.");
        toast.error("Failed to send message. Please try again.");
      }
    } catch (error) {
      setStatus("Error: Unable to send message.");
      toast.error("Error: Unable to send message.");
    }
  };

  return (
    <LayOut title={"Contact Us"}>
      <div className="contact-page">
        {/* Profile Section */}
        <motion.div
          className="profile-section"
          initial={{ opacity: 0, y: -50 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1 }}
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            padding: "20px",
            maxWidth: "500px",
            margin: "0 auto",
          }}
        >
          <motion.img
            src={ProfilePhoto}
            alt="User Profile"
            style={{
              width: "180px",
              height: "180px",
              objectFit: "cover",
              borderRadius: "50%",
              border: "3px solid pink",
              boxShadow: "0 4px 8px rgba(255,192,203,0.6)",
              transition: "transform 0.3s ease, box-shadow 0.3s ease",
            }}
            whileHover={{
              scale: 1.05,
              boxShadow: "0 8px 16px rgba(255,192,203,0.8)",
            }}
          />

          <motion.div
            className="social-icons"
            style={{
              marginTop: "15px",
              display: "flex",
              gap: "15px",
              justifyContent: "center",
            }}
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.5, duration: 1 }}
          >
            <a
              href="https://www.linkedin.com/in/akash-dubey-804511241/"
              target="_blank"
              rel="noopener noreferrer"
              style={{ color: "#0A66C2", fontSize: "24px" }}
            >
              <FaLinkedinIn />
            </a>
            <a
              href="https://github.com/uakashdk"
              target="_blank"
              rel="noopener noreferrer"
              style={{ color: "#171515", fontSize: "24px" }}
            >
              <FaGithubAlt />
            </a>
            <a
              href="https://discord.com/channels/@me"
              target="_blank"
              rel="noopener noreferrer"
              style={{ color: "#5865F2", fontSize: "24px" }}
            >
              <FaDiscord />
            </a>
            <a
              href="https://chat.whatsapp.com/EVzSoFGtNyK9BykLLppRAn"
              target="_blank"
              rel="noopener noreferrer"
              style={{ color: "#25D366", fontSize: "24px" }}
            >
              <FaWhatsapp />
            </a>
          </motion.div>
        </motion.div>

        {/* Contact Form */}
        <motion.form
          onSubmit={handleSubmit}
          style={{
            maxWidth: "500px",
            margin: "20px auto",
            display: "flex",
            flexDirection: "column",
            gap: "15px",
          }}
          initial={{ opacity: 0, scale: 0.8 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ delay: 1, duration: 1 }}
        >
          <motion.input
            type="text"
            name="name"
            placeholder="Your Name"
            value={formData.name}
            onChange={handleChange}
            style={{
              border: "2px solid pink",
              borderRadius: "5px",
              padding: "10px",
              backgroundColor: "#fdf6f9",
              color: "#333",
            }}
            whileFocus={{ borderColor: "deeppink" }}
          />
          <motion.input
            type="email"
            name="email"
            placeholder="Your Email"
            value={formData.email}
            onChange={handleChange}
            style={{
              border: "2px solid pink",
              borderRadius: "5px",
              padding: "10px",
              backgroundColor: "#fdf6f9",
              color: "#333",
            }}
            whileFocus={{ borderColor: "deeppink" }}
          />
          <motion.textarea
            name="message"
            placeholder="Your Message"
            value={formData.message}
            onChange={handleChange}
            rows="5"
            style={{
              border: "2px solid pink",
              borderRadius: "5px",
              padding: "10px",
              backgroundColor: "#fdf6f9",
              color: "#333",
            }}
            whileFocus={{ borderColor: "deeppink" }}
          />
          <motion.button
            type="submit"
            style={{
              padding: "10px 20px",
              fontWeight: "bold",
              borderRadius: "5px",
              border: "none",
              backgroundColor: "#007bff",
              color: "#fff",
              cursor: "pointer",
            }}
            whileHover={{ scale: 1.1, backgroundColor: "pink", color: "black" }}
          >
            Send
          </motion.button>
        </motion.form>
      </div>
    </LayOut>
  );
};

export default ContactPage;
